import { AppBox, AppPaper, AppText } from "../../../../../commons/components";
import AppBorderBox from "../../../../../commons/components/BorderBox";
import IconAddCircle from "../../../../../commons/components/icons/add-circle";
import { SurfaceColor } from "../../../../../commons/types/core-types";

type FormationBoxComponentProps = {
  onClick?: () => void;
  disabled?:boolean;
  isDropZone?: boolean;
};

export const FormationBoxComponent = ({disabled, onClick, isDropZone }: FormationBoxComponentProps) => {
  const handleClick = ()=>{
    if(!disabled && onClick){
    onClick()
    }
  }
  return (
    <AppBorderBox className="w-100 player-grid " borderVariant="dashed" borderColor="success" radius="md">
      <AppBox className="player-cell-container">
        <AppBox className="w-100" onClick={handleClick}>
          <AppPaper padding="none" bgColor={SurfaceColor.surface3} className={`w-100 player-add-display ${disabled ? 'disabled' : ''}`}>
            <AppBox py="xs" flexDirection="column" alignItems="center" justifyContent="center" gap="2xs">
              <IconAddCircle />
              <AppText>Add Player</AppText>
            </AppBox>
          </AppPaper>
        </AppBox>
      </AppBox>
    </AppBorderBox>
  );
};
